import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import PriceTable from "@/components/PriceTable";
import CTASection from "@/components/CTASection";
import ZWImage from "@/components/ZWImage";
import { WEITERE_ROWS, HINWEISE } from "@/data/services";

export default function WeitereLeistungen() {
  return (
    <>
      <SEO
        title="Weitere Leistungen – Umzug, Entrümpelung, Fassade & Dachrinne | ZWILLINGSWERK Herten"
        description="Umzugsservice 45 €/Std., Entrümpelung 80 €/m², Fassadenreinigung 5 €/m², Dachrinnenreinigung 4 €/lfm, Graffitientfernung 10 €/m² – ZWILLINGSWERK Herten + 20 km."
      />
      <PageHero
        eyebrow="Weitere Leistungen · Rund ums Objekt"
        title="Flexibel. Individuell. Zuverlässig."
        description="Unser Service geht über die klassischen Bereiche hinaus. Gerne unterstützen wir Sie auch bei weiteren Aufgaben rund um Ihr Objekt."
        testid="weitere-hero"
      />

      <section className="py-14 bg-[#F8FAF8] border-b border-[#D7E5D9]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
            <div className="lg:col-span-8">
              <PriceTable
                title="Weitere Leistungen & Sonderarbeiten"
                subtitle="Umzug, Montage, Entrümpelung, Reinigung von Fassade & Dachrinne"
                badge="Auf Anfrage kombinierbar"
                rows={WEITERE_ROWS}
                footnote="* Z. B. Glühbirnen wechseln, Türbeschläge nachstellen, kleine Ausbesserungen – soweit handwerklich zulässig."
                testid="price-table-weitere"
              />
            </div>

            <aside className="lg:col-span-4 space-y-6">
              <ZWImage
                src="/images/weitere.png"
                fallback="https://images.unsplash.com/photo-1581578731548-c64695cc6952?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
                alt="Terrassenreinigung mit Hochdruckreiniger durch ZWILLINGSWERK in Herten"
                className="w-full aspect-[4/3] rounded-2xl shadow-lg"
                subcaption="Spezialreinigung"
                caption="Pflaster, Terrasse & Fassade wie neu"
                testid="weitere-image"
              />
              <div className="bg-white border border-[#D7E5D9] rounded-2xl p-6 space-y-3 text-xs text-[#4A634E]">
                <h2 className="text-sm font-bold text-[#122B18] uppercase tracking-wider">Wichtige Hinweise</h2>
                <p>{HINWEISE.mindest}</p>
                <p>{HINWEISE.anfahrt}</p>
                <p>{HINWEISE.entsorgung}</p>
                <p>{HINWEISE.zahlung}</p>
              </div>
            </aside>
          </div>
        </div>
      </section>

      <CTASection />
    </>
  );
}
